import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'il-tabs-content',
    templateUrl: './tab-content.component.html',
    standalone: false
})
export class TabContentComponent {
    @Input() icon = '';
    @Input() label = '';
    @ViewChild('content') content!: TemplateRef<string>;
}